export default {
  fromStore(linksToUpdate, ganttInstance) {
    ganttInstance.batchUpdate(() => {
      linksToUpdate.forEach(link => {
        if (!ganttInstance.isLinkExists(link.id)) {
          return;
        }

        const ganttLink = ganttInstance.getLink(link.id);
        const updatedLink = { ...ganttLink, ...link };

        ganttInstance.silent(() => {
          ganttInstance.updateLink(link.id, updatedLink);
        });
      });
    });
  },

  fromGantt() {

  },
};
